import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./TabbedView.scss";

function TabbedView(props) {
  const { className, activeTab, tabs, onChange, ...rest } = props;
  const [currentActiveTab, setActiveTab] = useState(activeTab);
  const onTabClick = (tab) => {
    setActiveTab(tab);
    onChange(tab);
  };
  useEffect(() => {
    setActiveTab(activeTab);
  }, [activeTab]);
  return (
    <div className={`tabbed-view ${className}`} {...rest}>
      <div className="tabbed-view-headers">
        {tabs.map((tab) => {
          const isActiveCls = currentActiveTab === tab.value ? "active" : "";
          const isDisabledCls = tab.disabled ? "disabled" : "";
          return (
            <div
              key={`header-${tab.value}`}
              className={`tabbed-view-header ${isActiveCls} ${isDisabledCls}`}
              onClick={() => {
                if (tab.disabled) return;
                onTabClick(tab.value);
              }}
            >
              {tab.header}
            </div>
          );
        })}
      </div>
      <div className="tabbed-view-contents">
        {tabs.map((tab) => {
          const isActiveCls = currentActiveTab === tab.value ? "active" : "";
          const displayNoneCls = !isActiveCls ? "d-none" : "";
          const isDisabledCls = tab.disabled ? "disabled" : "";
          return (
            <div
              className={`tabbed-view-content ${isActiveCls} ${displayNoneCls} ${isDisabledCls}`}
              key={`content-${tab.value}`}
            >
              {tab.content}
            </div>
          );
        })}
      </div>
    </div>
  );
}

TabbedView.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      header: PropTypes.any,
      content: PropTypes.any,
      disabled: PropTypes.bool,
    })
  ),
  className: PropTypes.string,
  onChange: PropTypes.func,
  activeTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

TabbedView.defaultProps = {
  tabs: [],
  className: "",
  onChange: () => {},
  activeTab: null,
};

export default TabbedView;
